module.exports = __webpack_public_path__ + "img/logo.f863ad12.svg";